import SHARED from '../../constants';
import styles from './styles.module.scss';
// import AppImage from '../AppImage';
import icon from '../../../../assets/imgs/logo.png';
import blanckUser from '../../../../assets/imgs/blank-profile-picture.png';
import React, { Children, useContext } from 'react';
import { AdminContext } from '../../context/AdminContext';
import createImageSrc from '../../functions/CreateImageSrc';

const Avatar = ({
  src = icon,
  alt = 'user',
  onClick,
  height = '32px',
  width = '32px',
  containerclass = '',
  className = styles.avatar,
  local = false,
  extraClassName = 'nothing',
  children,
}) => {
  console.log('local', local, src);
  const { themeMode } = useContext(AdminContext);
  // const blanckUser = icon;
  return (
    <div
      onClick={onClick}
      className={`${styles.avatar} ${containerclass} relative `}
    >
      <img
        alt={alt}
        // src={src}
        src={`${
          local ? src : `${SHARED?.socketServerImage}${createImageSrc(src)}`
        }`}
        height={height}
        width={width}
        className={`${className} ${extraClassName}

        `}
      />
      {children}
    </div>
  );
};

export default Avatar;
